"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var __1 = require("../../..");
var DatePicker_1 = __importDefault(require("../../DatePicker/DatePicker"));
var Label_1 = __importDefault(require("../components/Label"));
var SDiv = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 6px;\n  margin-bottom: 20px;\n"], ["\n  margin-top: 6px;\n  margin-bottom: 20px;\n"])));
var DateFieldLabeled = function (_a) {
    var name = _a.name, label = _a.label, size = _a.size, readOnly = _a.readOnly, minDate = _a.minDate, maxDate = _a.maxDate, toolTip = _a.toolTip;
    var _b = formik_1.useField(name), field = _b[0], meta = _b[1], helpers = _b[2];
    var handleChange = function (d) {
        if (d === null) {
            helpers.setValue(undefined);
        }
        else {
            var x = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
            x.setFullYear(d.getFullYear());
            helpers.setValue(x.toISOString());
        }
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(Label_1.default, { htmlFor: name }, label),
        react_1.default.createElement(__1.Tooltip, { content: toolTip, disabled: !toolTip },
            react_1.default.createElement(SDiv, null,
                react_1.default.createElement(DatePicker_1.default, { onChange: handleChange, value: field.value, name: name, size: size, readOnly: readOnly, minDate: minDate, maxDate: maxDate, hasError: !!meta.error })))));
};
DateFieldLabeled.defaultProps = {
    size: undefined,
    readOnly: false,
    minDate: undefined,
    maxDate: undefined,
    toolTip: undefined,
};
exports.default = DateFieldLabeled;
var templateObject_1;
